export default __webpack_public_path__ + "static/media/underage.88cdb32e.png";